<section class="section-features-b">
    <h1 class="title">Características</h1>
    <div class="features-body scroll-gray">
        <div class="feature" *ngIf="carPower !== ''">
            <p>Potencia</p>
            <span [ngClass]="{'valueL': carPower.length > 5}" class="value">{{carPower}}<span class="unity">
                    Hp</span></span>
        </div>
        <div class="feature" *ngIf="carMotor !== ''">
            <p>Motor</p>
            <span class="value">{{carMotor}}<span class="unity"> Lts</span></span>
        </div>
        <div class="feature" *ngIf="carVelocidades !== ''">
            <p>Núm. Velocidades</p>
            <span class="value">{{carVelocidades}}</span>
        </div>
        <div class="feature" *ngIf="carTransmition !== ''">
            <p>Transmisión</p>
            <span class="value text-transmision">{{carTransmition | titlecase }}</span>
        </div>
    </div>
</section>